import { Component, Input, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core'
import { FormControl, ReactiveFormsModule } from '@angular/forms'
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MasksService } from 'src/app/services/masks/masks.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { maskitoTransform } from '@maskito/core'
import { TranslateConfigService } from 'src/app/services/translate-config.service';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, ReactiveFormsModule, TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class InputComponent implements OnInit {
  constructor(
    private masksService: MasksService,
    private router: Router,
    private utilsService: UtilsService,
    private translateService: TranslateService,
    private translateConfigService: TranslateConfigService
  ) {}
  @Input() outline: boolean = false
  @Input() disabled: boolean = false
  @Input() inputControl: FormControl | null = null;
  @Input() invalid: boolean = false
  @Input() field: any

  numberMask: any = this.masksService.getMask('number')
  nameMask = this.masksService.getMask('name')
  textMask = this.masksService.getMask('')

  setMask(form: any) {
    let mask: any
    if (form === 'phone') {
      mask = this.numberMask
    } else {
      mask = this.textMask
    }
    return mask
  }

  applyMask(value: any) {
    if (!this.inputControl) return

    let maskedValue = value
    switch (this.field.formControlName) {
      case 'phone':
        maskedValue = maskitoTransform(value, this.masksService.getMask('number'))
        break
      default:
        maskedValue = maskitoTransform(value, this.masksService.getMask(''))
    }

    this.inputControl.setValue(maskedValue, { emitEvent: true })
    this.inputControl.updateValueAndValidity()
  }

  getTranslatedPlaceholder(): string {
    if (!this.field || !this.field.placeholder) {
      return '';
    }

    return this.translateConfigService.getItemTranslated(this.field.placeholder);
  }

  ngOnInit() {
  }
}
